jQuery(document).ready(function($) {

    if( !$('.shopify-section--recommendations') ) {
        $('.Link--recommendations').hide();
    }

    $('.Link--recommendations').on('click', function() {
        const headerHeight = $('#section-header').height();
        if( $('.shopify-section--recommendations') ) {
          $('html, body').animate({
              scrollTop: $(".shopify-section--recommendations").offset().top - headerHeight - 30
          }, 1000);
        }
    });

    $('.ProductMeta__ShareTitle').on('click', function() {
        $(this).parent().toggleClass('active');
    });


    $.get("https://ipinfo.io", function(response) {
      var country    = response.country;
      var visibility = $(".Product").data("section-visibility");
      
      if( (country != 'GB') && (visibility == false) ) {
        $("body").addClass("uk-restricted");
        $(".ProductMeta__Links .swym-add-to-wishlist").hide();
        $(".ProductForm__AddToCart").hide();
        $("#mf_container").hide();
        $(".ProductForm__BuyButtons").before('<div class="restricted-msg">UK restrictions prevent this item being sent to your country. STILL WANT IT? Call +442074 830 688</div>');
      }
    }, "jsonp");

});



// js for live view
class LiveView extends HTMLElement {
  constructor() {
    super();
    this.min = this.dataset.min;
    this.max = this.dataset.max;
    this.interval = this.dataset.interval;
    this.message = this.dataset.message;
    this.init();
  }
  init() {
    if (this.message && this.max && this.min && this.interval) {
      this.handle();
      setInterval(() => {
        this.handle();
      }, this.interval * 1000);
    }
  }

  handle() {
    var message = "";
    message = this.message.replace(
      "[count]",
      this.randomSelect(parseInt(this.min), parseInt(this.max))
    );
    this.innerHTML = message;
  }

  randomSelect(min, max) {
    const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
    return randomNumber;
  }
}
customElements.define("live-view", LiveView);